import React from "react";
import classes from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={classes.Footer}>
      <div className={classes.FooterWrapper}>
        <div className={classes.SocialWrap}>
          <div className={classes.Shop}>
            <h3>Baccara Bar</h3>
            <ul className={classes.Social}>
              <li>
                <a href="https://www.facebook.com/BaccaraBar">
                  <img src="assets/icon/facebook.svg" alt="facebook logo" />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/baccara_bar/">
                  <img src="assets/icon/instagram.svg" alt="instagram logo" />
                </a>
              </li>
            </ul>
          </div>
          <div className={classes.Shop}>
            <h3>Σούσι Cocktail Bar</h3>
            <ul className={classes.Social}>
              {/* <li>
                <a href="https://www.facebook.com/romvaf">
                  <img src="assets/icon/facebook.svg" alt="facebook logo" />
                </a>
              </li> */}
              <li>
                <a href="https://www.instagram.com/sousikokteilbar_/">
                  <img src="assets/icon/instagram.svg" alt="instagram logo" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className={classes.Address}>
          <address>
            25ης Μαρτίου 46 Γωνία <span>Πτολεμαΐδα</span>
          </address>
          <a href="tel:+302463020001" className="telephone">
            2463020001
          </a>
        </div>
        <div className={classes.Developer}>
          <p>Web App Developed And Designed by</p>
          <h6>
            <a href="https://www.instagram.com/yanniotis/">Petros Gianniotis</a>
          </h6>
        </div>
      </div>
    </div>
  );
};

export default Footer;
